<mat-spinner 
  [diameter]="diameter()" 
  [style.--mdc-circular-progress-active-indicator-color]="styleService.styles().spinner.color">
</mat-spinner>
